// Global Nebim license-limit interceptor.
//
// Nebim V3 API bazen "LicenseLimitExceededException" hatası döndürüyor.
// Bu durum backend'in çoğu proxy endpoint'inde HTTP 503 + Türkçe mesaj olarak
// yakalanıyor, ama bazı sayfa/endpoint kombinasyonlarında raw hata mesajı
// (response body içinde "LicenseLimitExceededException" veya
// "Nebim kullanıcı lisansınız") frontend'e ulaşabiliyor.
//
// Bu interceptor `window.fetch`'i sarmalayıp HER API cevabını kontrol eder;
// license-limit belirtisi görünce global `nebim-license-limit` custom event'i
// tetikler. App.js'te dinlenen bu event, kullanıcıya sabit metinli
// `NebimLicenseLimitModal`'ı gösterir.
//
// İşlem tek sefer çalıştırılabilir (idempotent) ve orijinal fetch'i bozmaz.

const LICENSE_LIMIT_PATTERNS = [
  'LicenseLimitExceededException',
  'Nebim kullanıcı lisansınız',
  'Nebim V3 Kullanıcı limitini',
];

const containsLicenseLimit = (text) => {
  if (!text) return false;
  const s = String(text);
  return LICENSE_LIMIT_PATTERNS.some((p) => s.includes(p));
};

let installed = false;

export const installNebimLicenseInterceptor = () => {
  if (installed || typeof window === 'undefined' || !window.fetch) return;
  installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    // Sadece JSON yanıtları kontrol et; body'yi tüketmeden clone'la
    try {
      const contentType = (response.headers.get('content-type') || '').toLowerCase();
      if (contentType.includes('application/json') || contentType.includes('text/plain')) {
        const cloned = response.clone();
        // Async body inspect — response'u ana akışta blocklamayalım
        cloned.text().then((text) => {
          if (containsLicenseLimit(text)) {
            window.dispatchEvent(new CustomEvent('nebim-license-limit'));
          }
        }).catch(() => { /* ignore */ });
      }
    } catch { /* ignore inspection errors */ }

    return response;
  };
};
